import { render, staticRenderFns } from "./LangSelectComponent.vue?vue&type=template&id=27c1977a&scoped=true"
import script from "./LangSelectComponent.vue?vue&type=script&lang=js"
export * from "./LangSelectComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27c1977a",
  null
  
)

export default component.exports